import { mapState, mapGetters } from "vuex";

export default {
    data() {
        return {
            freemiumThemesAvailable: 1
        }
    },
    computed: {
        ...mapState({
            accessTypeIds: state => state.AccessTypes.idList
        }),
        ...mapGetters({
            isLoggedIn: "User/isLoggedIn"
        })
    },
    methods: {
        $_freemiumBiLocked() {
            const isFremiumBi = this.bookInsight.access_type == this.accessTypeIds.FREEMIUM;
            return isFremiumBi && !this.isLoggedIn;
        },
        $_scrollToSignUpWall(scrollBehaviour = {}) {
            const element = document.getElementById("signup-wall");
            if (!element) {
                return;
            }
            element.scrollIntoView(scrollBehaviour);
        }
    }
}
